<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active" @click="sort('name')">
				Navn
			</th>
			<th class="sortable" @click="sort('typename')">
				Type
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(product, index) in (sortedActivity, filteredList)" :key="index" @click="editProduct(product)" :title="product.description ? 'Beskrivelse: ' + product.description : null">
					<td>
						{{ product.name }}
					</td>
					<td>
						{{ product.typename }}
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(product, index) in (sortedActivity, filteredList)" :key="index" @click="editProduct(product)">
					<td>
						<ul class="flex-content">
							<li data-label="Navn">{{ product.name }}</li>
							<li data-label="Type">{{ product.typename }}</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen produkter fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Der er endnu ikke oprettet nogen produkter
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";

	export default {
		name: "ProductsList",
		data: () => ({
			data: [],
			currentSort: "name",
			currentSortDir: "asc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		props: ["search"],
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html
				var products = this.data
				return products.sort((a, b) =>
				{
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			},
			filteredList()
			{
				var products = this.data
				return products.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase());
					let typename = data.typename.toLowerCase().match(this.search.toLowerCase());
					return name || typename;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			}
		},
		created()
		{
			this.loadData()
		},
		methods:
		{
			async loadData()
			{
				this.setComponentAsBusy()
				await this.$store.dispatch(types.ACTION_GET_PRODUCTS)
					.then(response =>
					{
						this.data = response.data

						for (var product of this.data)
						{
							product.typename = this.getProductTypeName(product)
						}

						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("ProductsList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					});
			},
			getProductTypeName(product)
			{
				switch (product.type)
				{
					case 1:
						return "Portræt"
					case 2:
						return "Gruppefoto"
					case 3:
						return "Video"
					case 4:
						return "USB stick"
					case 5:
						return "Bog"
					default:
						return "Andet"
				}
			},
			editProduct(product)
			{
				this.$router.push({ name: "ProductEdit", params: { productid: product.id } })
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++;
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--;
			}
		}
	}
</script>
